'use strict';

import { format } from "~/helpers/search";

export default function SearchListItemRoute({ route }) {
    const { from, to, date, date_to } = route;
    const showDateTo = !!date_to && date != date_to;
    return <div className="el-flight__direction">
        <div className="el-flight__direction-way">
            {!!from && <div>{from.city}</div>}
            {!!to && <div><span>→</span> {to.city}</div>}
        </div>
        <div className="el-flight__direction-date">
            {!!date && <div>{format(date)} {showDateTo && '—'}</div>}
            {showDateTo && <div>{format(date_to)}</div>}
        </div>
    </div>;
}

